import { useState } from 'react'
import { resetPassword } from '../../../../lib/utils/api'

export const useSubmit = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | undefined>(undefined)
  const [success, setSuccess] = useState<boolean | undefined>(undefined)

  const submit = async (email: string) => {
    setLoading(true)
    setSuccess(undefined)
    setError(undefined)

    try {
      const res = await resetPassword(email)
      if (res.data) {
        setSuccess(true)
      }
      setLoading(false)
    } catch (e) {
      setError(e.message)
      setLoading(false)
    }
  }

  return { loading, error, submit, success }
}
